<template>
  <div>
    <v-card color="grey lighten-4" flat tile>
      <MenuContexto
        desativar-listas-preco
        desativar-observacao
      >
        <v-toolbar color="#042333" dark>
          <v-app-bar-nav-icon
            @click="setDrawerMenu(true)"
            color="white"
          ></v-app-bar-nav-icon>
          <v-toolbar-title class="titulo-empresa" @click="linkDashboard()">
            <img
              :src="empresa.logo_header"
              class="img-empresa-header"
              width="230"
            />
          </v-toolbar-title>

          <portal-target name="portal-menu-principal-topbar" tag="div" class="w-full d-flex">
            <div class="ml-6 d-flex align-center">
              <portal-target name="inputs-grupo-filial" tag="div" class="d-flex align-center">
                <v-select
                  v-model="selects.grupos.value"
                  :items="grupos"
                  outlined
                  dense
                  label="Grupo de Compras"
                  height="8"
                  item-value="id"
                  item-text="descricao"
                  color="#fff"
                  @change="mudarGrupo"
                  hide-details
                  style="max-width: 220px"
                ></v-select>

                <v-select
                  v-show="exibeFilialCompra"
                  v-model="selects.filiais_compra.value"
                  :items="itensFiliaisDinamico"
                  outlined
                  dense
                  label="Filial"
                  item-value="id"
                  item-text="descricao"
                  height="8"
                  color="#fff"
                  style="width: 160px"
                  hide-details
                  class="ml-5"
                  @change="mudarFilialCompra"
                />

                <GrupoFilialComprasDinamicosDialog
                  v-if="exibir_configuracao_grupo_compras_usuario_computed"
                  class="ml-1 mr-n2"
                  @processamento:finalizado="alteracaoGrupoComprasUsuario"
                />
              </portal-target>

              <portal-target name="append-inputs-grupo-filial" tag="div" class="d-flex align-center">

              </portal-target>
            </div>

            <v-spacer />

            <portal-target name="portal-nome-cliente" tag="div" class="d-flex align-center">
              <div class="w-max-35-porcento-screen">
                <p v-text="licenciamento" :title="licenciamento" class="ma-0 text-no-wrap text-truncate" />
                <p
                  v-if="data_ult_integracao.length"
                  v-text="`Última atualização: ${data_ult_integracao || 'carregando... aguarde'}`"
                  class="ma-0 font-13 text-right"
                />
              </div>
            </portal-target>

            <dialog-release-notes class="pl-3" />
          </portal-target>

          <drawer-notification v-if="notification == 'true'" />

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-show="$route.name == 'Compra'"
                @click="drawerAtividade = !drawerAtividade"
                icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-timer-sand</v-icon>
              </v-btn>
            </template>
            <span>Listagem do seu histórico de atividades</span>
          </v-tooltip>
        </v-toolbar>
      </MenuContexto>
    </v-card>
    <drawer-menu @rRelatorio="sRelatorio($event)" />
    <activity-log
      :abrirHistorico="drawerAtividade"
      @fecharHistorico="drawerAtividade = $event"
    ></activity-log>
    <portal-target name="drawer-de-notificacao"></portal-target>
    <alterar-senha />
    <autorizacao />

    <component
      v-if="Object.keys(relatorios).some(chave_url => (chave_url === relatorioSelecionado.url))"
      v-model="dialog_relatorio"
      :relatorio="relatorioSelecionado"
      :is="relatorios[relatorioSelecionado.url]"
    />

    <dialog-relatorio
      v-else
      :cont="cont"
      :relatorio="relatorioSelecionado"
    />

    <v-dialog v-model="dialogAtualizacao" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <v-icon>mdi-update</v-icon>&nbsp;
          <span class="headline ml-3">Atualização Disponível</span>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="px-0">
          <v-progress-linear
            v-show="temporizadorUmMinuto > 0"
            indeterminate
            color="error"
          ></v-progress-linear>

          <p class="mt-3 mx-5">
            Uma ou mais atualizações estão disponíveis no sistema. Isso levará
            apenas alguns segundos.
          </p>
        </v-card-text>

        <v-card-actions style="margin-top: -25px">
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            @click="atualizarSistema"
            :disabled="temporizadorUmMinuto > 0"
          >
            Confirmar
            <span v-show="temporizadorUmMinuto > 0"
            >({{ temporizadorUmMinuto }})</span
            >
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import UsuarioAPI from "./../../api/usuario";
import DrpAPI from "./../../api/drp";
import { mapState, mapGetters, mapMutations } from "vuex";
import dialogRelatorio from "./dialogRelatorioMenu";
import autorizacao from "./../workflow/autorizacao/Dialog";
import drawerMenu from "./DrawerMenu.vue";
import drawerNotification from "./DrawerNotification.vue";
import AlterarSenha from "./../auth/AlterarSenha";
import MenuContexto from "../utils/MenuContexto.vue";
import DashboardAPI from "./../../api/dashboard";
import {relatorios} from '@/components/Relatorios/Index';
import activityLog from "./ActivityLog";
import DialogReleaseNotes from "./DialogReleaseNotes.vue";
import GrupoFilialComprasDinamicosDialog from "@/components/compra/ProdutosGerais/Filtros/GrupoFilialComprasDinamicosDialog/Index.vue";
import {useGrupoComprasUsuario} from "@/components/compra/ProdutosGerais/Filtros/GrupoFilialComprasDinamicosDialog/grupoDinamicoUsuario";
import {onMounted} from "vue";

export default {
  components: {
    dialogRelatorio,
    autorizacao,
    drawerMenu,
    drawerNotification,
    AlterarSenha,
    activityLog,
    MenuContexto,
    DialogReleaseNotes,
    GrupoFilialComprasDinamicosDialog,
  },
  data() {
    return {
      data_ult_integracao: "",
      notification: window.__APP_CONFIG__.VUE_APP_NOTIFICATION,
      selects: {
        grupos: {
          items: [],
          value: "",
        },
        filiais_compra: {
          items: [{ id: 0, descricao: "Geral", filial: "0" }],
          value: 0,
        },
      },
      cont: 0,
      relatorioSelecionado: {},
      atualizacao_auto_sistema: "",
      dialogAtualizacao: false,
      drawerAtividade: false,
      temporizadorUmMinuto: 30,
      relatorios,
      dialog_relatorio: false
    };
  },
  computed: {
    ...mapGetters({
      grupoCompras: "usuario/getGrupoCompras",
      grupos: "usuario/getGrupos",
      filialCompras: "usuario/getFilialCompras",
      exibeFilialCompra: "usuario/getExibeFilialCompra",
      configuracoes: "configuracoes/carrinho",
    }),
    ...mapState("app", ["empresa"]),
    licenciamento() {
      return localStorage.getItem("empresa");
    },
    nameRotaAtual () {
      return this.$route.name
    },
    itensFiliaisDinamico () {
      let itens = [].concat(this.selects.filiais_compra.items)

      const {COMPRA_MULTIFILIAIS} = this.configuracoes

      if (this.grupoCompras > 0 && COMPRA_MULTIFILIAIS === 'S' && this.nameRotaAtual === 'Compra') {
        const objMultFilial = {id: -1, descricao: 'Multifiliais', filial: -1}

        itens.push(objMultFilial)
      }

      return itens
    },
    exibir_configuracao_grupo_compras_usuario_computed() {
      return this.$route.name === 'Compra' && localStorage.compras_exibir_grupo_compras_usuario === 'S';
    },
  },
  created() {
    this.buscarGrupos();
    this.atualizacaoAutoSistema();
    this.mudarFilialCompra();
    this.infoUltimaIntegracao();
  },
  watch: {
    grupoCompras() {
      this.selects.grupos.value = this.grupoCompras;
      this.ativaExibicaoFilial();
      this.buscarFiliaisCompras();

      if (this.selects.grupos.value === 0) {
        this.selects.filiais_compra.items[0].descricao = 'Multigrupos'
        this.selects.filiais_compra.value = 0
        this.removeFiliaisMenosMulti()
        this.mudarFilialCompra()
      }

      if (this.selects.filiais_compra.value > 0) {
        this.selects.filiais_compra.value = 0
      }
    },
    filialCompras() {
      this.selects.filiais_compra.value = this.filialCompras;
    }
  },
  methods: {
    ...mapMutations("app", ["setDrawerMenu"]),
    infoUltimaIntegracao() {
      const headers = this.Helpers.iniciarRequisicao();

      this.$store.dispatch(
        "loading/addRequisicao",
        DashboardAPI.getUltimaDataIntegracao(headers)
          .then((response) => {
            const {token, data_ultima_integracao} = response.data;
            localStorage.setItem("token", token);
            this.data_ult_integracao = data_ultima_integracao.data_ult_integracao || '';
          })
          .catch(() => {
            this.$store.dispatch("loading/habilitarLoading", false);
            this.Helpers.logout();
          })
      )
    },
    removeFiliaisMenosMulti () {
      const {items} = this.selects.filiais_compra;

      const filiaisMulti = items.filter(filial => [-1, 0].includes(filial.id));

      this.selects.filiais_compra.items = filiaisMulti
    },
    atualizacaoAutoSistema() {
      const atualizacao_auto = localStorage.getItem("atualizacao_auto");
      if (atualizacao_auto == "S") {
        this.dialogAtualizacao = true;

        let tmp = setInterval(() => {
          this.temporizadorUmMinuto -= 1;

          if(this.$store.state.loading.qtde_requisicoes == 0){
            this.temporizadorUmMinuto = 0;
          }

          if (this.temporizadorUmMinuto <= 0) {
            clearInterval(tmp);
          }
        }, 1000);
      }
    },
    atualizarSistema() {
      const headers = this.Helpers.getHeaderRequisicao();
      const params = { id: localStorage.getItem("id") };
      UsuarioAPI.setAtualizarSistema(headers, params)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          localStorage.setItem("atualizacao_auto", "N");
          document.location.reload(true);
        })
        .catch(() => {
          this.Helpers.logout();
        });
    },
    mudarGrupo() {
      this.$store.dispatch(
        "usuario/setGrupoCompras",
        this.selects.grupos.value
      );
      this.ativaExibicaoFilial();
    },
    mudarFilialCompra() {
      this.$store.dispatch(
        "usuario/setFilialCompras",
        this.selects.filiais_compra.value
      );
    },
    ativaExibicaoFilial() {
      let filial_compra = localStorage.getItem("filial_compra");
      if (
        !this.exibeFilialCompra &&
        this.$route.name === 'Compra' &&
        filial_compra === "S"
      ) {
        this.$store.dispatch("usuario/setExibeFilialCompra", true);
      }
    },
    buscarGrupos() {
      const headers = this.Helpers.getHeaderRequisicao();
      DrpAPI.getGruposDrp(headers)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          const grupos = response.data.grupos;

          this.$store.dispatch("usuario/setGrupos", grupos);

          grupos.forEach((grupo) => {
            this.selects.grupos.items.push(grupo);
          });

          let grupo_padrao = Number(localStorage.getItem("config_grupo_compra_padrao")) || 1;

          this.$store.dispatch("usuario/setGrupoCompras", grupo_padrao);

          this.selects.grupos.value = grupo_padrao;

          this.buscarFiliaisCompras();
        })
        .catch(() => {
          this.Helpers.logout();
        });
    },
    buscarFiliaisCompras() {
      if (this.selects.grupos.value > 0) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = {
          grupo: this.selects.grupos.value,
        };

        this.$store.dispatch("loading/habilitarLoading", false);

        DrpAPI.getFiliaisDrp(headers, params)
          .then((response) => {
            const {token} = response.data;
            localStorage.setItem("token", token);

            this.selects.filiais_compra.items = [];

            const filiais = response.data.filiais.map(item => {
              item.descricao = `${item.descricao} ${item.nome_fantasia ? `- ${item.nome_fantasia}` : ''}`
              return  item;
            });

            let objFilial = { id: 0, descricao: "Geral", filial: 0 };

            this.selects.filiais_compra.items.push(objFilial);

            filiais.forEach((filial) => {
              if (filial.filial_cd === "N" || filial.ativar_exibicao_filial_cd_tela_compras) {
                this.selects.filiais_compra.items.push(filial)
              }
            })

            this.$store.dispatch("usuario/setFilialCompras", this.selects.filiais_compra.value);
          })
          .catch(() => {
            this.Helpers.logout();
          });
      } else if (this.$route.name !== 'Compra') {
        this.$store.dispatch("usuario/setExibeFilialCompra", false);
      } else {
        this.selects.filiais_compra.value = 0
      }
    },
    linkDashboard() {
      const drp = localStorage.getItem("service");

      if (drp === "S") {
        this.$router.push("/logistica");
      } else {
        this.$router.push("/dashboard");
      }
    },
    sRelatorio(prop) {
      this.relatorioSelecionado = prop;
      this.cont = this.cont + 1;
      this.dialog_relatorio = true;
    },
    alteracaoGrupoComprasUsuario() {
      this.buscarFiliaisCompras();

      const grupo_dinamico_usuario = useGrupoComprasUsuario();
      grupo_dinamico_usuario.gerenciarExibicaoGrupo({ exibir_grupo_dinamico: true });
      this.$store.dispatch('tabela_compra/setAtualizarTelaCompraCount');
    },
  },
};
</script>
<style scoped>
.titulo-empresa {
  color: #fff;
  cursor: pointer;
}

.img-empresa-header {
  padding: 3% 5% 5% 5%;
  margin-top: 5%;
  margin-left: -15%;
}
</style>

<style>
/*
**   ESTE CSS É ACESSÍVEL EM TODO O SISTEMA
*/

@media (max-height: 10000px) {
  .altura-responsiva-grafico-indicador {
    height: 735px !important;
  }
}

@media (max-height: 1040px) {
  .altura-responsiva-grafico-indicador {
    height: 690px !important;
  }
}

@media (max-height: 940px) {
  .altura-responsiva-grafico-indicador {
    height: 555px !important;
  }
}

@media (max-height: 900px) {
  .altura-responsiva-grafico-indicador {
    height: 505px !important;
  }
}

@media (max-height: 850px) {
  .altura-responsiva-grafico-indicador {
    height: 455px !important;
  }
}

@media (max-height: 800px) {
  .altura-responsiva-grafico-indicador {
    height: 405px !important;
  }
}

@media (max-height: 750px) {
  .altura-responsiva-grafico-indicador {
    height: 355px !important;
  }
}

@media (max-height: 700px) {
  .altura-responsiva-grafico-indicador {
    height: 285px !important;
  }
}

.titulo-tabela-top .v-data-table__wrapper table thead tr th {
  vertical-align: top;
}

.font-resp-tabela .v-data-table__wrapper table tbody tr td {
  font-size: 9pt;
  /* font-size: calc(8px + .30vw); */
}

.font-resp {
  font-size: 9pt;
  /* font-size: calc(8px + .30vw); */
}

/* css global para indicadores */
.simple-table-indicadores .v-data-table__wrapper table thead th {
  font-size: 12px;
  text-align: left;
}

.simple-table-indicadores .v-data-table__wrapper table tbody tr td {
  font-size: 12px;
  text-align: left;
  padding: 0;
}

/* css para tabelas full screen */

.table-full-screen .v-data-table__wrapper table thead tr th {
  vertical-align: top !important;
  padding-left: 6px !important;
  text-align: left !important;
  padding-top: 5px !important;
  font-size: 12px !important;
}
.table-full-screen .v-data-table__wrapper table tbody tr td {
  padding-left: 6px !important;
  text-align: left !important;
  padding-top: 5px !important;
  font-size: 12px !important;
}

.table-full-screen-responsiva .v-data-table__wrapper {
  height: calc(100vh - 190px) !important;
}
</style>
